import Equpmanet from './tablepart';

export default Equpmanet;
